<div class="fuse-vertical-navigation-item-badge ng-star-inserted">
    <div class="fuse-vertical-navigation-item-badge-content text-teal-500" [matTooltip]="'Currently connected users'"> {{appConnectedSessions()}} Active Sessions </div>
</div>